import { logIn, register } from "../api";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Account({setLoggedIn, setToken, username, setUsername}) {
    const [password, setPassword] = useState("");
    const [haveAccount, setHaveAccount] = useState(true);
    const [invalidLogin, setInvalidLogin] = useState(false);
    const [userAlreadyExist, setUserAlreadyExist] = useState(false);
    const [passwordTooShort, setPasswordTooShort] = useState(false);
    const navigate = useNavigate();

    const loggingIn = async (username, password) => {
        try {
            const result = await logIn(username, password);
            if(result.token) {
                setToken(result.token);
                setLoggedIn(true);
                localStorage.setItem("token", result.token);
                navigate("/");
            } else {
                setInvalidLogin(true);
            }
        } catch (err) {
            console.error("Log in failed", err);
        }
    };

    const registering = async (username, password) => {
        try {
            const result = await register(username, password);
            console.log(result)
            if(result.token) {
                setToken(result.token);
                setLoggedIn(true);
                localStorage.setItem("token", result.token);
                navigate("/");
                setUserAlreadyExist(false);
                setPasswordTooShort(false);
            } else if(result.error === "Password Too Short!") {
                setPasswordTooShort(true);
            } else {
                setUserAlreadyExist(true);
            }
        } catch (err) {
            console.error("Unable to register user!", err);
        }
    }

    return <div>
        {
            haveAccount ? <div className="account-container">
                <form onSubmit={(event) => {
                    event.preventDefault();
                    loggingIn(username, password);
                }}>
                    <h2>Log In</h2>
                    <div className="form-element">
                        <label>Username</label>
                        <input type="text" value={username} onChange={(event) => {setUsername(event.target.value)}}></input>
                    </div>
                    <div>
                        <label>Password</label>
                        <input type="password" value={password} onChange={(event) => {setPassword(event.target.value)}}></input>
                    </div>
                    <button className="account-navigate" onClick={() => {
                    setHaveAccount(false);
                    setInvalidLogin(false);
                    }}>Don't have an account? Sign up!</button>
                    <button type="submit" className="form-button">Submit</button>
                </form>
                {
                    invalidLogin ? <div className="error">Invalid username or password!</div> : <></>
                }
            </div> : <div className="account-container">
                <form onSubmit={(event) => {
                    event.preventDefault();
                    registering(username, password);
                }}>
                    <h2>Register</h2>
                    <div className="form-element">
                        <label>Username</label>
                        <input type="text" value={username} onChange={(event) => {
                            setUsername(event.target.value);
                            setUserAlreadyExist(false);
                            setPasswordTooShort(false);
                            }}></input>
                    </div>
                    <div className="form-element">
                        <label>Password</label>
                        <input type="password" value={password} onChange={(event) => {
                            setPassword(event.target.value);
                            setPasswordTooShort(false);
                            setUserAlreadyExist(false);
                            }}></input>
                    </div>
                    <button type="submit" className="form-button">Submit</button> 
                </form>
                <button className="account-navigate" onClick={() => {
                    setHaveAccount(true);
                    setUserAlreadyExist(false);
                    setPasswordTooShort(false);
                    }}>Have an account? Sign in!</button>
                {
                    userAlreadyExist ? <div className="error">Username already exists!</div> : <></>
                }
                {
                    passwordTooShort ? <div className="error">Password must be 8 characters or longer!</div> : <></>
                }
            </div>
                
        } 


    </div>
};